import { type Signal } from '@angular/core'
import { injectQuery } from '@tanstack/angular-query-experimental'
import { injectCartoClient } from '../services/carto.helper'
import {
  fetchAggregations,
  type AggregationsFilters,
} from '../services/aggregations.service'

export {
  type AggregationRow,
  type AggregationsFilters,
} from '../services/aggregations.service'

export function injectAggregationsQuery(filters: Signal<AggregationsFilters>) {
  const cartoClient = injectCartoClient()

  return injectQuery(() => ({
    queryKey: ['aggregations', filters()],
    queryFn: async ({ signal }) => {
      return fetchAggregations(cartoClient, filters(), signal)
    },
    enabled: filters().delivery_id > 0,
  }))
}
